/* global angular, _, $ */
angular.module('ua5App.home')
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.when('', '/');
        $stateProvider.state('home', {
            url: '/?:tag&:program&:category',
            templateUrl: 'states/home/home.html',
            controller: 'HomeCtrl',
            controllerAs: 'ctrl',
            reloadOnSearch: false,
            params: {
                tag: {
                    value: '',
                    squash: true
                },
                program: {
                    value: '',
                    squash: true
                },
                category: {
                    value: '',
                    squash: true
                }
            },
            resolve: {
                posts: ['PostFactory', '$stateParams', function(PostFactory, $stateParams) {
                    var filters = {
                        category: $stateParams.category || '',
                        program:  $stateParams.program || '',
                        tag:  $stateParams.tag || ''
                    };

                    return PostFactory.posts().query(filters).$promise;
                }]
            }
        });
    }])
    .controller('HomeCtrl', ['posts', '$scope', 'PostFactory', 'MetaFactory', '$stateParams', '$location', function(posts, $scope, PostFactory, MetaFactory, $stateParams, $location) {

        $scope.stateParams = $stateParams;
        $scope.posts = [];

        $scope.postFilters = {
            category: $scope.stateParams.category || '',
            program:  $scope.stateParams.program || '',
            tag:  $scope.stateParams.tag || ''
        };

        function sortPosts(posts) {
            $scope.posts = posts;
        }

        function reloadPosts(filters) {
            var homeFilters = $.extend({homeFeed: true}, filters);
            PostFactory.posts().query(homeFilters).$promise.then(function(posts) {
                sortPosts(posts);
                $scope.postFilters = $.extend({}, filters);
            });
        }

        $scope.updateURL = function(filters) {
            filters.category = (filters.category && filters.category !== '') ? filters.category : null;
            filters.program = (filters.program && filters.program !== '') ? filters.program : null;
            filters.tag = (filters.tag && filters.tag !== '') ? filters.tag : null;
            $location.search('category', filters.category);
            $location.search('program', filters.program);
            $location.search('tag', filters.tag);
        };

        sortPosts(posts);

        $scope.$on('postFilterChange', function(e, filters) {
            if (_.isEqual(filters, $scope.postFilters)) {
                return;
            } else {
                reloadPosts(filters);
                $scope.updateURL(filters);
            }
        });

        $scope.$on('$stateChangeStart', function(e, toState) {
            // check to make sure it's a child state
            if (toState.name.indexOf('home.') === 0 && toState.name !== $scope.lastState) {
                $('#ui-state-holder').fadeOut(250);
            }
        });

        $scope.$on('$stateChangeSuccess', function(e, toState) {
            // check to make sure it's a child state
            if (toState.name.indexOf('home.') === 0 && toState.name !== $scope.lastState) {
                $('#ui-state-holder').fadeIn(250);
                $scope.lastState = toState.name;
            } else if (toState.name === 'home') {
                $scope.lastState = toState.name;
                $scope.updateURL($scope.postFilters);
            }
        });
    }])
;
